<p-dialog
  draggable="false"
  [header]="'webScanning.scanDocuments' | translate"
  [modal]="true"
  [closable]="true"
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
>
  <div class="scanner-layout">
    <div class="scanner-controls">
      <div class="scanner-source-container">
        <div class="form-field">
          <label
            id="scannerSelectLabel"
            class="scanner-label"
            for="scannerSelect"
          >
            {{ 'webScanning.selectScanner' | translate }}
          </label>
          <div class="scanner-select-row">
            <p-select
              placeholder="{{ 'webScanning.selectScanner' | translate }}"
              class="dap-select-scanner"
              id="scannerSelect"
              [options]="sources"
              [ariaLabelledBy]="'scannerSelectLabel'"
              [(ngModel)]="selectedSource"
            ></p-select>
          </div>
        </div>
      </div>

      <div class="upload-settings-container">
        <div class="upload-settings-header">
          <span class="settings-header-text">{{ 'webScanning.uploadSettings' | translate }}</span>
        </div>
        <div class="scan-toggle-group">
          <div class="scan-toggle-row">
            <label for="separatePages"> {{ 'webScanning.eachPageNewDocument' | translate }} </label>
            <p-toggleswitch
              class="dap-seperate-pages-toggle"
              id="separatePages"
              [ariaLabel]="'webScanning.eachPageNewDocument' | translate"
              [disabled]="splitAtBlankPage"
              [(ngModel)]="eachPageAsDocument"
            />
          </div>
          <div class="scan-toggle-row">
            <label for="blankPageSplit"> {{ 'webScanning.blankPageSeparator' | translate }} </label>
            <p-toggleswitch
              class="dap-blank-page-seperator"
              id="blankPageSplit"
              [ariaLabel]="'webScanning.blankPageSeparator' | translate"
              [disabled]="eachPageAsDocument"
              [(ngModel)]="splitAtBlankPage"
            />
          </div>
        </div>
      </div>

      <p-panel class="scanner-settings-panel">
        <ng-template pTemplate="header">
          <div class="flex items-center gap-2">
            <span class="font-bold"> {{ 'webScanning.webScannerSettings' | translate }} </span>
          </div>
        </ng-template>
        <ng-template pTemplate="icons">
          <p-button
            label="{{ 'webScanning.scannerUI' | translate }}"
            class="dap-advanced-settings-btn"
            size="small"
            variant="text"
            severity="secondary"
            icon="fa-regular fa-arrow-up-right-from-square"
            iconPos="right"
            [disabled]="!selectedSource"
            (onClick)="useScannerUi()"
          ></p-button>
        </ng-template>
        <div class="scanner-settings-container">
          <div class="form-row">
            <div class="form-field">
              <label
                id="colorDepthLabel"
                class="scanner-label"
                for="colorDepthSelect"
              >
                {{ 'webScanning.colorDepth' | translate }}
              </label>
              <p-select
                class="dap-color-depth-select"
                id="colorDepthSelect"
                appendTo="body"
                [options]="colorDepthOptions"
                [ariaLabelledBy]="'colorDepthLabel'"
                [(ngModel)]="scanSettings.colorDepth"
              ></p-select>
            </div>
            <div class="form-field">
              <label
                id="dpiLabel"
                class="scanner-label"
                for="dpiSelect"
              >
                {{ 'webScanning.dpi' | translate }}
              </label>
              <p-select
                class="dap-dpi-select"
                id="dpiSelect"
                appendTo="body"
                [ariaLabelledBy]="'dpiLabel'"
                [options]="dpiOptions"
                [(ngModel)]="scanSettings.dpi"
              ></p-select>
            </div>
          </div>
          <div class="settings-toggle-group">
            <div class="settings-toggle-row">
              <label for="feederToggle"> {{ 'webScanning.scanFeeder' | translate }} </label>
              <p-toggleswitch
                class="dap-feeder-toggle"
                id="feederToggle"
                [ariaLabel]="'webScanning.scanFeeder' | translate"
                [(ngModel)]="scanSettings.feederEnabled"
              />
            </div>
          </div>
          <div class="scan-btn-container">
            <div class="scan-button">
              <p-button
                class="dap-scan-btn"
                styleClass="w-full"
                severity="secondary"
                [label]="'webScanning.scan' | translate"
                [disabled]="!DWTObject || !selectedSource"
                (onClick)="scan()"
              ></p-button>
            </div>
          </div>
        </div>
      </p-panel>
    </div>
    <div class="scanner-preview">
      <div
        id="dwtcontrolContainer"
        role="region"
        [attr.aria-label]="'webScanning.scannerPreview' | translate"
      ></div>
    </div>

    @if (isLoading) {
      <div class="loading-overlay">
        <p-progressSpinner
          strokeWidth="4"
          animationDuration="1s"
        ></p-progressSpinner>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="scanner-footer-right">
      <p-button
        class="dap-cancel-scan"
        severity="secondary"
        variant="text"
        [label]="'cancel' | translate"
        (onClick)="closeDialog()"
      ></p-button>
      <p-button
        class="dap-upload-scanned-docs"
        icon="fa-regular fa-upload"
        iconPos="left"
        [label]="'webScanning.upload' | translate"
        [disabled]="!DWTObject || DWTObject.HowManyImagesInBuffer === 0"
        (onClick)="processScannedFiles()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
